<template class="rounded-xl">
	<div class="data-table-container customize-table">
		<v3-table :headers="headers" :items="itemsToDisplay" alternating :rows-per-page="rowsPerPage" hide-rows-per-page
			hide-footer :search-field="searchField" :search-value="searchValue" @click-row="selectIncident">
			<template #header-createdat="header">
				<div class="text-left cursor-pointer" @click="sortDate">
					{{ $t('date_and_time') }}
				</div>
			</template>
			<template #header-description="header">
				<div class="text-left cursor-pointer" @click="sortDate">
					{{ $t('date_and_time') }}
				</div>
			</template>
			<template #header-status="header">
				<div class="text-left cursor-pointer" @click="sortDate">
					{{ $t('date_and_time') }}
				</div>
			</template>
			<template #item-description="{ description, name }">
				<div class="font-weight-bold text-body-1" :class="name == 'Administrator'
					? 'text-red-lighten-2'
					: name == 'Owner'
						? 'text-green-lighten-2'
						: 'text-grey'
					">
					{{ name == 'Administrator' ? 'ADMIN' : name.toUpperCase() }}
				</div>
				<div>
					{{ description }}
				</div>
			</template>
			<template #item-status="{ active }">
				<v-chip :class="active ? 'active-status' : 'inactive-status'" density="default" variant="flat"><v-icon
						start icon="mdi-circle" :class="active
							? 'active-status-icon'
							: 'inactive-status-icon'
							"></v-icon>{{ active ? $t('Active') : $t('Inactive') }}
				</v-chip>
			</template>
		</v3-table>

		<v-row class="mt-4 ml-4">
			<v-col cols="4" md="8" class="d-flex align-center">
				{{ $t('total') }}: {{ items.length }} {{ $t('role') }}
			</v-col>

			<v-col cols="8" md="4">
				<v-pagination size="small" :length="Math.ceil(items.length / rowsPerPage)"
					class="custom-pagination mb-2" :model-value="currentPage" @update:model-value="updateCurrentPage">
					<template #next="{ disabled }">
						<v-btn icon size="small" rounded="xl" class="ml-2" variant="flat" :disabled="disabled" @click="
							(currentPage += 1),
							updateCurrentPage(currentPage)
							">
							<v-icon> mdi-chevron-right </v-icon>
						</v-btn>
					</template>

					<template #prev="{ disabled }">
						<v-btn icon size="small" rounded="xl" class="mr-2" variant="flat" :disabled="disabled" @click="
							(currentPage -= 1),
							updateCurrentPage(currentPage)
							">
							<v-icon> mdi-chevron-left </v-icon>
						</v-btn>
					</template>
				</v-pagination>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import Vue3EasyDataTable from 'vue3-easy-data-table'
import 'vue3-easy-data-table/dist/style.css'

export default {
	name: 'DataTable',
	components: {
		'v3-table': Vue3EasyDataTable,
	},
	props: {
		headers: Array,
		items: Array,
		rowsPerPage: {
			type: Number,
			default: 6,
		},
	},
	emits: ['sendIncidents', 'closeTable'],
	methods: {
		updateCurrentPage(page) {
			this.currentPage = page
		},
		selectIncident(data) {
			this.$emit('sendIncidents', data)
		},
		closeIncidentTable() {
			this.$emit('closeTable')
		},
	},
	data: () => ({
		currentPage: 1,
		colorCode: {
			low: 'gray',
			normal: 'green',
			high: 'yellow',
			urgent: 'red',
		},
		itemSelected: [],
		linkedIncidents: [],
		searchField: ['title', 'client.name', 'status'],
		searchValue: '',
	}),
	computed: {
		itemsToDisplay() {
			// Reverse the array to display the latest items at the top
			const reversedItems = [...this.items].reverse()

			const startIndex = (this.currentPage - 1) * this.rowsPerPage
			const endIndex = startIndex + this.rowsPerPage

			// Slice the reversed array
			return reversedItems.slice(startIndex, endIndex)
		},
	},
}
</script>
<style scoped>
.customize-table {
	--easy-table-border: 1px solid var(--primary-color-lighten);
	--easy-table-row-border: 1px solid var(--primary-color-lighten);
	--easy-table-header-font-size: 18px;
	--easy-table-header-height: 50px;
	--easy-table-header-background-color: var(--secondary-color);
	--easy-table-header-item-padding: 15px 20px;
	/* --easy-table-header-font-color: white; */

	--easy-table-body-row-background-color: var(--secondary-color-lighten);
	--easy-table-body-row-height: 50px;
	--easy-table-body-row-font-size: 16px;
	--easy-table-body-row-hover-background-color: var(--primary-color-lighten);

	--easy-table-body-item-padding: 10px 15px;
	--easy-table-footer-background-color: var(--gray-1);
	--easy-table-footer-font-size: 14px;
	--easy-table-footer-padding: 0px 10px;
	--easy-table-footer-height: 50px;

	--easy-table-loading-mask-background-color: #000000;
	font-family: 'Roboto';
}

.active-status {
	background-color: #d3f9dc;
	color: green;
	padding: 10px;
	width: 100px;
	/* margin-align: auto; */
	display: flex;
	justify-content: center;
	font-weight: bold;

	/* border-radius: 10px; */
}

.active-status-icon {
	color: green;
}

.inactive-status-icon {
	color: rgb(172, 44, 44);
}

.inactive-status {
	background-color: #f09d70;
	color: rgb(172, 44, 44);
	padding: 10px;
	width: 100px;
	text-align: center;
	display: flex;
	justify-content: center;
	font-weight: bold;
	/* border-radius: 10px; */
}

.link {
	font-weight: 500;
	cursor: pointer;
}
</style>
